import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { Redirect, Link } from "react-router-dom";

import {
	getFilterConfig,
	getCarSetting,
	getVehicleType,
	getVehicleMake,
	getVehicleModel,
	registerCar,
	checkLicensePlate,
} from "../../model/car";
import { getLoggedProfile as baseGetProfile } from "../../model/profile";
import { getLoggedProfile } from "../../actions/sessionAct";
import Login from "../login/login";
import Header from "../components/header";
import Footer from "../components/footer";
import CarRegisterInfo from "./carregisterInfo";
import CarRegisterPhotos from "./carregisterPhotos";
import CarRegisterRenting from "./carregisterRenting";
import CarRegisterRentingwd from "./carregisterRentingwd";
import ChangePhone from "../account/changephone";
import VerifyPhone from "../account/verifyphone";
import { commonErr } from "../common/errors";
import { MessageBox } from "../common/messagebox";
import { LoadingOverlay } from "../common/loading";
import { formatPrice, DEFAULT_INSTANT_RANGE_FROM, DEFAULT_INSTANT_RANGE_TO, otpAction } from "../common/common";
import VerifyPhoneOpt from "../account/verifyphoneopt";
import VerifyPhoneOptBreak from "../account/verifyphoneoptbreak";

import { IcBackReport } from "../common/svg";
import { MODE_REGISTER } from "../../constant/routes";

class CarRegister extends React.Component {
	constructor() {
		super();
		this.state = {
			minStep: 1,
			maxStep: 3,
			step: 1,
			err: commonErr.INNIT,
			errMsg: "",

			//info
			inviteCode: "",
			licensePlate: "",
			address: "",
			lat: 0,
			lng: 0,
			cityId: 0,
			districtId: 0,
			wardId: 0,
			street: "",

			vehicleType: 0,
			vehicleMake: 0,
			vehicleModel: 0,
			year: 2017,
			seat: 4,
			transmission: 1,
			fuel: 1,
			fuelRate: 10,
			desc: "",
			features: [],

			//photos
			photos: [],
			isShowConfirmPhotos: false,

			//renting for both 2 mode
			price: 1000000,
			isDiscount: true,
			isInstantly: false,
			instantRangeFrom: DEFAULT_INSTANT_RANGE_FROM,
			instantRangeTo: DEFAULT_INSTANT_RANGE_TO,
			isDelivery: true,
			isLimited: true,
			policy: "",
			discountWeek: 5,
			discountMonth: 10,
			deliveryRadius: 30,
			deliveryPrice: 20000,
			limited: 400,
			limitedPrice: 20000,
			isShowConfirmInstant: false,
			isShowAdditionalPapers: false,
			idCode: "",
			idDate: "",
			idIssuer: "",
			taxCode: "",
			taxDate: "",
			taxIssuer: "",
		};
	}

	componentDidMount() {
		baseGetProfile().then((resp) => {
			if (resp.data.data && resp.data.data.profile) {
				const profile = resp.data.data.profile;
				if (!profile.phoneNumber || profile.phoneNumber === "") {
					this.setState({
						showChangePhone: true,
					});
				} else if (!profile.phoneVerified || profile.phoneVerified === 0) {
					this.setState({
						showVerifyPhone: true,
						profile: profile,
					});
				}
			} else {
				this.setState({
					showLoginForm: true,
				});
			}
		});

		getFilterConfig().then((resp) => {
			if (resp.data.data) {
				this.setState({
					featuresAll: resp.data.data.allFeatures,
				});
			}
		});

		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});

		getVehicleMake(0).then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleMakes: resp.data.data.vehicleMakes,
				});
			}
		});
		window.scrollTo(0, 0);
	}

	//session
	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	showLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	goNext = async () => {
		const message = await this.isValidNext();
		if (message === "") {
			this.setState({
				step: this.state.step + 1,
			});
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message,
			});
		}
	};

	goPrev = () => {
		this.setState({
			step: this.state.step - 1,
		});
	};

	reset = () => {
		this.setState({
			step: 1,
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	hideWarningBox = () => {
		this.setState({
			warn: commonErr.INNIT,
			warnMessage: "",
		});
	};

	toggleShowAdditionalPapers = async () => {
		const message = await this.isValidNext();
		if (message !== "") {
			this.setState({
				err: commonErr.FAIL,
				errMsg: message,
			});
		} else {
			this.setState({
				isShowAdditionalPapers: !this.state.isShowAdditionalPapers,
				isShowConfirmPhotos: false,
			});
		}
	};

	onAdditionalPapersChange = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
		});
	};

	isValidInfo = async () => {
		var message = "";
		const { licensePlate, vehicleType, vehicleMake, vehicleModel, year, seat, transmission, fuel, fuelRate } =
			this.state;
		if (!licensePlate || licensePlate === "") {
			message = "Vui lòng nhập biển số.";
		} else {
			return await checkLicensePlate(licensePlate).then((checkLicensePlateResp) => {
				if (
					checkLicensePlateResp.data &&
					checkLicensePlateResp.data.error === 0 &&
					checkLicensePlateResp.data.data.alreadyExist === 1
				) {
					message = "Biển số đã được đăng kí rồi.";
					// } else if (!vehicleType || vehicleType <= 0) {
					//     message = "Bạn chưa chọn loại xe.";
				} else if (!vehicleMake || vehicleMake <= 0) {
					message = "Bạn chưa chọn hãng xe.";
				} else if (!vehicleModel || vehicleModel <= 0) {
					message = "Bạn chưa chọn mẫu xe.";
				} else if (!year || year <= 0) {
					message = "Bạn chưa chọn năm sản xuất.";
				} else if (!seat || seat <= 0) {
					message = "Bạn chưa chọn số ghế.";
				} else if (!transmission || transmission <= 0) {
					message = "Bạn chưa chọn truyền động.";
				} else if (!fuel || fuel <= 0) {
					message = "Bạn chưa chọn loại nhiên liệu.";
				} else if (!fuelRate || fuelRate <= 0) {
					message = "Bạn chưa chọn mức tiêu thụ nhiên liệu.";
				}
				return message;
			});
		}

		return message;
	};

	isValidPhotos = () => {
		var message = "";
		const { photos } = this.state;
		if (!photos || photos.length <= 0) {
			message = "Bạn chưa upload hình cho xe";
		}
		// if (photos.length < 3) {
		// 	message = "Bạn cần upload ít nhất 3 hình cho xe";
		// }
		return message;
	};

	isShowConfirmPhotos = () => {
		const { photos } = this.state;
		if (photos.length >= 1 && photos.length <= 4) {
			this.setState({
				isShowConfirmPhotos: true,
			});
		} else {
			this.toggleShowAdditionalPapers();
		}
	};

	toggleShowConfirmPhotos = () => {
		this.setState({
			isShowConfirmPhotos: !this.state.isShowConfirmPhotos,
		});
	};

	isValidPapers() {
		return "";
	}

	// for 2 mode, separate each mode
	isValidRenting() {
		var message = "";
		//self drive
		if (this.props.match.params.mode === "selfdrive") {
			if (!this.state.price || this.state.price <= 0) {
				message = "Bạn chưa chọn giá cho xe.";
			} else if (
				this.state.price > this.state.setting.priceDailyMax ||
				this.state.price < this.state.setting.priceDailyMin
			) {
				message = `Giá không hợp lệ. Giá cho phép trong khoản từ ${formatPrice(
					this.state.setting.priceDailyMin
				)} đến ${formatPrice(this.state.setting.priceDailyMax)}.`;
			} else if (!this.state.address || this.state.address === "") {
				message = "Bạn chưa chọn địa chỉ xe.";
			} else if (this.state.lat === 0 || this.state.lng === 0) {
				message = "Địa chỉ không hợp lệ.";
			}
		}
		// with driver
		else if (this.props.match.params.mode === "withdriver") {
			// check terms for basePrice
			if (!this.state.basePrice || this.state.basePrice <= 0) {
				message = "Bạn chưa chọn giá cho xe.";
			} else if (
				this.state.basePrice > this.state.setting.priceDailyMax ||
				this.state.basePrice < this.state.setting.priceDailyMin
			) {
				message = `Giá không hợp lệ. Giá cho phép trong khoản từ ${formatPrice(
					this.state.setting.priceDailyMin
				)} đến ${formatPrice(this.state.setting.priceDailyMax)}.`;
			} else if (
				this.state.extraKMFee > this.state.setting.extraKMFeeMax ||
				this.state.extraKMFee < this.state.setting.extraKMFeeMin
			) {
				message = `Phí phụ thu vượt km không hợp lệ. Phí phụ thu vượt km cho phép trong khoản từ ${formatPrice(
					this.state.setting.extraKMFeeMin
				)} đến ${formatPrice(this.state.setting.extraKMFeeMax)}.`;
			} else if (
				this.state.extraHourFee > this.state.setting.extraHourFeeMax ||
				this.state.extraHourFee < this.state.setting.extraHourFeeMin
			) {
				message = `Phí phụ thu vượt giờ không hợp lệ. Phí phụ thu vượt giờ cho phép trong khoản từ ${formatPrice(
					this.state.setting.extraHourFeeMin
				)} đến ${formatPrice(this.state.setting.extraHourFeeMax)}.`;
			} else if (!this.state.address || this.state.address === "") {
				message = "Bạn chưa chọn địa chỉ xe.";
			} else if (this.state.lat === 0 || this.state.lng === 0) {
				message = "Địa chỉ không hợp lệ.";
			}
		}

		return message;
	}

	isValidNext = async () => {
		if (this.state.step === 1) {
			return await this.isValidInfo();
		} else if (this.state.step === 2) {
			return this.isValidRenting();
		} else if (this.state.step === 3) {
			return this.isValidPhotos();
		}
	};

	// for 2 mode, separate each mode
	register = async () => {
		const profile = this.props.session.profile.info;

		if (!profile.phoneNumber || profile.phoneNumber === "" || !profile.phoneVerified || profile.phoneVerified === 0) {
			this.setState({
				showChangePhone: true,
			});
		} else {
			let data = {};
			if (this.props.match.params.mode === "selfdrive") {
				data = {
					inviteCode: this.state.inviteCode,
					lp: this.state.licensePlate,
					vehicleModelId: this.state.vehicleModel,
					seat: this.state.seat,
					year: this.state.year,

					instant: this.state.isInstantly,
					instantRangeFrom: this.state.instantRangeFrom,
					instantRangeTo: this.state.instantRangeTo,

					lat: this.state.lat,
					lon: this.state.lng,
					cityId: this.state.cityId,
					districtId: this.state.districtId,
					wardId: this.state.wardId,
					street: this.state.street,
					addr: this.state.address,

					deliveryEnable: this.state.isDelivery,
					deliveryRadius: this.state.deliveryRadius,
					deliveryPrice: this.state.deliveryPrice,
					deliveryRadiusFree: this.state.deliveryRadiusFree,

					limitEnable: this.state.isLimited,
					limitKM: this.state.limited,
					limitPrice: this.state.limitedPrice,

					photoTmpIds: this.state.photos,

					transmission: this.state.transmission,
					fuel: this.state.fuel,
					fuelConsumption: this.state.fuelRate,
					features: this.state.features,
					desc: encodeURI(this.state.desc),

					notes: encodeURI(this.state.policy),

					requiredPapers: "",
					requiredPapersSpecific: "",
					requiredPapersOther: "",

					priceDaily: this.state.price,

					discountEnable: this.state.isDiscount,
					discountWeekly: this.state.discountWeek,
					discountMonthly: this.state.discountMonth,

					// mode param
					selfDrive: true,
				};
			} else if (this.props.match.params.mode === "withdriver") {
				data = {
					// step 1: info
					inviteCode: this.state.inviteCode,
					lp: this.state.licensePlate, //bien so
					vehicleModelId: this.state.vehicleModel,
					seat: this.state.seat,
					year: this.state.year,
					transmission: this.state.transmission,
					fuel: this.state.fuel,
					fuelConsumption: this.state.fuelRate,
					features: this.state.features,
					desc: encodeURI(this.state.desc), //mo ta xe

					// step 2: renting
					// intant booking
					instant: this.state.isInstantly,
					instantRangeFrom: this.state.instantRangeFrom,
					instantRangeTo: this.state.instantRangeTo,
					// adrr
					lat: this.state.lat,
					lon: this.state.lng,
					cityId: this.state.cityId,
					districtId: this.state.districtId,
					wardId: this.state.wardId,
					street: this.state.street,
					addr: this.state.address,
					// delivery
					wdDeliveryEnable: this.state.isDelivery,
					wdDeliveryRadius: this.state.deliveryRadius,
					wdDeliveryPrice: this.state.deliveryPrice,
					wdDeliveryRadiusFree: this.state.deliveryRadiusFree,
					// policies
					wdPolicies: encodeURI(this.state.policy),
					// base price
					wdBasePrice: this.state.basePrice,
					// extraFee
					wdExtraKMFee: this.state.extraKMFee,
					wdExtraHourFee: this.state.extraHourFee,

					// step 3: photo
					photoTmpIds: this.state.photos,
					//  mode param
					selfDrive: false,
				};
			}

			this.setState({
				isShowAdditionalPapers: false,
				err: commonErr.LOADING,
			});
			registerCar(data).then((resp) => {
				if (resp.data.error >= 0) {
					window.location.href = `/mycars`;
				} else {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};
	// ON CHANGE
	//info
	onInviteCodeChange = (event) => {
		this.setState({
			inviteCode: event.target.value,
		});
	};

	onLicensePlateChange = (event) => {
		this.setState({
			licensePlate: event.target.value,
		});
	};

	// onAddressChange = (event) => {
	//     this.setState({
	//         address: event.target.value
	//     });
	// }

	onAddressLocationUpdate = (location) => {
		this.setState({
			address: location.address,
			lat: location.lat,
			lng: location.lng,
			cityId: location.cityId,
			districtId: location.districtId,
			wardId: location.wardId,
			street: location.street,
		});
	};

	onVehicleTypeChange = (event) => {
		const vehicleType = event.target.value;
		if (vehicleType > 0) {
			getVehicleMake(vehicleType).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleType: vehicleType,
						vehicleMakes: resp.data.data.vehicleMakes,
					});
				}
			});
		} else {
			this.setState({
				vehicleType: 0,
				vehicleMake: 0,
				vehicleModel: 0,
			});
		}
	};

	onVehicleMakeChange = (event) => {
		const vehicleMake = event.target.value;
		if (vehicleMake > 0) {
			const vehicleType = this.state.vehicleType;
			getVehicleModel(vehicleType, vehicleMake).then((resp) => {
				if (resp.data.data) {
					this.setState({
						vehicleMake: vehicleMake,
						vehicleModels: resp.data.data.vehicleModels,
					});
				}
			});
		} else {
			this.setState({
				vehicleMake: 0,
				vehicleModel: 0,
			});
		}
	};
	// for 2 mode, separate each mode
	onVehicleModelChange = (event) => {
		const vehicleModel = event.target.value;
		this.setState({
			vehicleModel: vehicleModel,
		});

		if (vehicleModel !== 0) {
			getCarSetting({ vehicleModelId: vehicleModel }).then((resp) => {
				const data = resp.data.data;

				if (this.props.match.params.mode === "selfdrive") {
					const data = resp.data.data;
					if (data) {
						this.setState({
							price: data.priceDailyRecommend,
							discountWeekly: data.discountWeeklyRecommend,
							discountMonthly: data.discountMonthlyRecommend,
							deliveryRadius: data.deliveryRadiusRecommend,
							deliveryPrice: data.deliveryPriceRecommend,
							deliveryRadiusFree: data.deliveryRadiusFreeRecommend,
							limitKM: data.limitKMRecommend,
							limitedPrice: data.limitPriceRecommend,
							setting: data,
						});
					}
				} else if (this.props.match.params.mode === "withdriver") {
					const data = resp.data.data.wdSetting;
					if (data) {
						this.setState({
							basePrice: data.basePriceRecommend,
							extraKMFee: data.extraKMFeeRecommend,
							extraHourFee: data.extraHourFeeRecommend,

							deliveryRadius: data.deliveryRadiusRecommend,
							deliveryPrice: data.deliveryPriceRecommend,
							deliveryRadiusFree: data.deliveryRadiusFreeRecommend,

							setting: data,
						});
					}
				}
			});
		}
	};

	onYearChange = (event) => {
		const year = event.target.value;
		const { vehicleModel } = this.state;
		this.setState({
			year: year,
		});
		if (year !== 0) {
			getCarSetting({ vehicleModelId: vehicleModel, year: year }).then((resp) => {
				const data = resp.data.data;

				if (this.props.match.params.mode === "selfdrive") {
					const data = resp.data.data;
					if (data) {
						this.setState({
							price: data.priceDailyRecommend,
							discountWeekly: data.discountWeeklyRecommend,
							discountMonthly: data.discountMonthlyRecommend,
							deliveryRadius: data.deliveryRadiusRecommend,
							deliveryPrice: data.deliveryPriceRecommend,
							deliveryRadiusFree: data.deliveryRadiusFreeRecommend,
							limitKM: data.limitKMRecommend,
							limitedPrice: data.limitPriceRecommend,
							setting: data,
						});
					}
				} else if (this.props.match.params.mode === "withdriver") {
					const data = resp.data.data.wdSetting;
					if (data) {
						this.setState({
							basePrice: data.basePriceRecommend,
							extraKMFee: data.extraKMFeeRecommend,
							extraHourFee: data.extraHourFeeRecommend,

							deliveryRadius: data.deliveryRadiusRecommend,
							deliveryPrice: data.deliveryPriceRecommend,
							deliveryRadiusFree: data.deliveryRadiusFreeRecommend,

							setting: data,
						});
					}
				}
			});
		}
	};

	onSeatChange = (event) => {
		const seat = event.target.value;
		this.setState({
			seat: seat,
		});
	};

	onTransmisionChange = (event) => {
		const transmission = event.target.value;
		this.setState({
			transmission: transmission,
		});
	};

	onFuelChange = (event) => {
		const fuel = event.target.value;
		this.setState({
			fuel: fuel,
		});
	};

	onFuelRateChange = (event) => {
		const fuelRate = event.target.value;
		this.setState({
			fuelRate: fuelRate,
		});
	};

	onDescChange = (event) => {
		const desc = event.target.value;
		this.setState({
			desc: desc,
		});
	};

	onFeaturesChange = (event) => {
		var i;
		var features = [];
		if (this.state.features) {
			features = features.concat(this.state.features);
		}

		const feature = event.target.value;
		if (event.target.checked) {
			features.push(feature);
		} else {
			for (i = features.length - 1; i >= 0; --i) {
				if (features[i] === feature) {
					features.splice(i, 1);
				}
			}
		}

		const featuresAll = [];
		for (i = 0; i < this.state.featuresAll.length; ++i) {
			const feature = this.state.featuresAll[i];
			if (event.target.value === feature.id) {
				feature.checked = event.target.checked;
			}
			featuresAll.push(feature);
		}

		this.setState({
			features: features,
			featuresAll: featuresAll,
		});
	};

	//photos
	handlePhotoInputChange = (photo) => {
		var photos = [];
		if (this.state.photos) {
			photos = photos.concat(this.state.photos);
		}
		photos.push(photo);

		this.setState({
			photos: photos,
		});
	};

	removeCarPhoto = (photo) => {
		var photos = [];
		if (this.state.photos) {
			photos = photos.concat(this.state.photos);
		}
		photos = photos.filter(function (p) {
			return p.id !== photo.id;
		});

		this.setState({
			photos: photos,
		});
	};

	//renting
	// common
	onCloseModal = () => {
		this.setState({
			isShowConfirmInstant: false,
		});
	};

	toggleInstantly = () => {
		var instant = !this.state.isInstantly;
		this.setState({
			isInstantly: instant,
			isShowConfirmInstant: instant,
		});
		if (instant) {
			this.setState({
				instantRangeFrom:
					!this.state.instantRangeFrom || this.state.instantRangeFrom === 0
						? DEFAULT_INSTANT_RANGE_FROM
						: this.state.instantRangeFrom,
				instantRangeTo:
					!this.state.instantRangeTo || this.state.instantRangeTo === 0
						? DEFAULT_INSTANT_RANGE_TO
						: this.state.instantRangeTo,
			});
		}
	};

	onInstantRangeFromChange = (event) => {
		this.setState({
			instantRangeFrom: event.target.value,
		});
	};

	onInstantRangeToChange = (event) => {
		this.setState({
			instantRangeTo: event.target.value,
		});
	};

	toggleDelivery = () => {
		this.setState({
			isDelivery: !this.state.isDelivery,
		});
	};

	onPolicyChange = (event) => {
		this.setState({
			policy: event.target.value,
		});
	};

	hideChangePhone = () => {
		this.setState({
			showChangePhone: false,
		});
	};

	hideVerifyPhone = () => {
		this.setState({
			showVerifyPhone: false,
		});
	};

	showVerifyPhoneOpt = () => {
		this.hideChangePhone();
		this.setState({
			showVerifyPhoneOpt: true,
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: false,
		});
	};

	// getProfile = () => {
	// 	this.props.dispatch(getLoggedProfile());
	// };

	// seperate
	// self drive
	onPriceRangeChange = (event) => {
		if (isNaN(event.target.value)) {
			return;
		}
		this.setState({
			price: event.target.value * 1000,
		});
	};

	toggleDiscount = () => {
		this.setState({
			isDiscount: !this.state.isDiscount,
		});
	};

	onDiscountWeekRangeChange = (range) => {
		this.setState({
			discountWeek: range.value,
		});
	};

	onDiscountMonthRangeChange = (range) => {
		this.setState({
			discountMonth: range.value,
		});
	};

	toggleLimited = () => {
		this.setState({
			isLimited: !this.state.isLimited,
		});
	};

	onLimitedChange = (range) => {
		this.setState({
			limited: range.value,
		});
	};

	onLimitedPriceRangeChange = (range) => {
		this.setState({
			limitedPrice: range.value,
		});
	};
	// with driver

	onDeliveryPriceChange = (range) => {
		this.setState({
			deliveryPrice: range.value,
		});
	};

	onDeliveryRadiusChange = (range) => {
		this.setState({
			deliveryRadius: range.value,
		});
	};

	onDeliveryRadiusFreeChange = (range) => {
		this.setState({
			deliveryRadiusFree: range.value,
		});
	};

	onBasePriceChange = (event) => {
		if (isNaN(event.target.value)) {
			return;
		}
		this.setState({
			basePrice: event.target.value * 1000,
		});
	};

	onExtraKMFeeChange = (event) => {
		if (isNaN(event.target.value)) {
			return;
		}
		this.setState({
			extraKMFee: event.target.value * 1000,
		});
	};

	onExtraHourFeeChange = (event) => {
		if (isNaN(event.target.value)) {
			return;
		}
		this.setState({
			extraHourFee: event.target.value * 1000,
		});
	};

	render() {
		const { mode } = this.props.match.params;
		const { cityId, districtId, wardId, street, idCode } = this.state;

		if (mode !== "selfdrive" && mode !== "withdriver") return <Redirect to="/notfound" />;

		return (
			<div className="mioto-layout">
				<Header />
				<section className="body">
					<div className="module-register">
						<div className="m-container">
							<div className="main-title">
								<Link className="back d-flex" to={MODE_REGISTER}>
									<div className="wrap-svg">
										<IcBackReport />
									</div>
									<p>Quay lại</p>
								</Link>
								<h4>Đăng ký xe</h4>
							</div>
						</div>
						<div className="register-container">
							<div className="content-register">
								<div className="stepbystep">
									<ul>
										<li className={this.state.step === 1 ? "active" : ""}>
											<span className="nu">1</span>
											<span className="value">Thông tin</span>
										</li>
										<li className={this.state.step === 2 ? "active" : ""}>
											<span className="nu">2</span>
											<span className="value">Cho thuê</span>
										</li>
										<li className={this.state.step === 3 ? "active" : ""}>
											<span className="nu">3</span>
											<span className="value">Hình ảnh</span>
										</li>
									</ul>
								</div>
								{this.state.step === 1 && (
									<CarRegisterInfo
										inviteCode={this.state.inviteCode}
										licensePlate={this.state.licensePlate}
										vehicleType={this.state.vehicleType}
										vehicleTypes={this.state.vehicleTypes}
										vehicleMake={this.state.vehicleMake}
										vehicleMakes={this.state.vehicleMakes}
										vehicleModels={this.state.vehicleModels}
										vehicleModel={this.state.vehicleModel}
										year={this.state.year}
										seat={this.state.seat}
										transmission={this.state.transmission}
										fuel={this.state.fuel}
										fuelRate={this.state.fuelRate}
										desc={this.state.desc}
										features={this.state.features}
										featuresAll={this.state.featuresAll}
										onInviteCodeChange={this.onInviteCodeChange}
										onLicensePlateChange={this.onLicensePlateChange}
										onVehicleTypeChange={this.onVehicleTypeChange}
										onVehicleMakeChange={this.onVehicleMakeChange}
										onVehicleModelChange={this.onVehicleModelChange}
										onYearChange={this.onYearChange}
										onSeatChange={this.onSeatChange}
										onTransmisionChange={this.onTransmisionChange}
										onFuelChange={this.onFuelChange}
										onFuelRateChange={this.onFuelRateChange}
										onDescChange={this.onDescChange}
										onFeaturesChange={this.onFeaturesChange}
									/>
								)}

								{this.state.step === 2 &&
									(mode === "selfdrive" ? (
										<CarRegisterRenting
											price={this.state.price}
											isDiscount={this.state.isDiscount}
											discountWeek={this.state.discountWeek}
											discountMonth={this.state.discountMonth}
											address={this.state.address}
											lat={this.state.lat}
											lng={this.state.lng}
											cityId={cityId}
											districtId={districtId}
											wardId={wardId}
											street={street}
											isInstantly={this.state.isInstantly}
											instantRangeFrom={this.state.instantRangeFrom}
											instantRangeTo={this.state.instantRangeTo}
											isDelivery={this.state.isDelivery}
											deliveryRadius={this.state.deliveryRadius}
											deliveryPrice={this.state.deliveryPrice}
											deliveryRadiusFree={this.state.deliveryRadiusFree}
											isLimited={this.state.isLimited}
											limited={this.state.limited}
											limitedPrice={this.state.limitedPrice}
											policy={this.state.policy}
											setting={this.state.setting}
											onPriceRangeChange={this.onPriceRangeChange}
											toggleDiscount={this.toggleDiscount}
											onDiscountWeekRangeChange={this.onDiscountWeekRangeChange}
											onDiscountMonthRangeChange={this.onDiscountMonthRangeChange}
											// onAddressChange={this.onAddressChange}
											onAddressLocationUpdate={this.onAddressLocationUpdate}
											toggleInstantly={this.toggleInstantly}
											onCloseModal={this.onCloseModal}
											onInstantRangeFromChange={this.onInstantRangeFromChange}
											onInstantRangeToChange={this.onInstantRangeToChange}
											toggleDelivery={this.toggleDelivery}
											onDeliveryRadiusChange={this.onDeliveryRadiusChange}
											onDeliveryPriceChange={this.onDeliveryPriceChange}
											onDeliveryRadiusFreeChange={this.onDeliveryRadiusFreeChange}
											toggleLimited={this.toggleLimited}
											onLimitedChange={this.onLimitedChange}
											onLimitedPriceRangeChange={this.onLimitedPriceRangeChange}
											onPolicyChange={this.onPolicyChange}
										/>
									) : (
										mode === "withdriver" && (
											<CarRegisterRentingwd
												address={this.state.address}
												lat={this.state.lat}
												lng={this.state.lng}
												cityId={cityId}
												districtId={districtId}
												wardId={wardId}
												street={street}
												// onAddressChange={this.onAddressChange}
												onAddressLocationUpdate={this.onAddressLocationUpdate}
												isInstantly={this.state.isInstantly}
												toggleInstantly={this.toggleInstantly}
												instantRangeFrom={this.state.instantRangeFrom}
												onInstantRangeFromChange={this.onInstantRangeFromChange}
												instantRangeTo={this.state.instantRangeTo}
												onInstantRangeToChange={this.onInstantRangeToChange}
												isDelivery={this.state.isDelivery}
												toggleDelivery={this.toggleDelivery}
												policy={this.state.policy}
												onPolicyChange={this.onPolicyChange}
												onCloseModal={this.onCloseModal}
												// gia co ban
												basePrice={this.state.basePrice}
												onBasePriceChange={this.onBasePriceChange}
												// phu thu gio
												extraHourFee={this.state.extraHourFee}
												onExtraHourFeeChange={this.onExtraHourFeeChange}
												// phu thu km
												extraKMFee={this.state.extraKMFee}
												onExtraKMFeeChange={this.onExtraKMFeeChange}
												deliveryRadius={this.state.deliveryRadius}
												onDeliveryRadiusChange={this.onDeliveryRadiusChange}
												deliveryPrice={this.state.deliveryPrice}
												onDeliveryPriceChange={this.onDeliveryPriceChange}
												deliveryRadiusFree={this.state.deliveryRadiusFree}
												onDeliveryRadiusFreeChange={this.onDeliveryRadiusFreeChange}
												// setting: phan cho cac value recommend
												setting={this.state.setting}
											/>
										)
									))}
								{this.state.step === 3 && (
									<CarRegisterPhotos
										photos={this.state.photos}
										handlePhotoInputChange={this.handlePhotoInputChange}
										removeCarPhoto={this.removeCarPhoto}
									/>
								)}
								{this.state.err === commonErr.LOADING && <LoadingOverlay />}
								<MessageBox
									show={this.state.err < commonErr.SUCCESS}
									hideModal={this.hideMessageBox}
									message={this.state.errMsg}
								/>
								<Login
									show={this.state.showLoginForm}
									showModal={this.openLoginForm}
									hideModal={this.closeLoginForm}
									getLoggedProfile={this.getLoggedProfile}
								/>
								<Modal
									show={this.state.isShowConfirmInstant}
									onHide={this.onCloseModal}
									dialogClassName="modal-s modal-confirm">
									<Modal.Header closeButton={true} closeLabel={""}>
										<h5>Thông báo</h5>
									</Modal.Header>
									<Modal.Body>
										<div className="modal-confirm-body" style={{ background: "none", padding: "0" }}>
											<div className="textAlign-center">
												<p className="font-16">Bạn có chắc chắn rằng xe của bạn luôn sẵn sàng cho&nbsp;thuê?</p>
												<p className="font-12">
													Bạn cần đảm bảo việc cần cập nhật lịch bận xe thường xuyên, trường hợp hủy chuyến sau khi
													khách đặt cọc vì chưa cập nhật lịch bận sẽ áp dụng phí hủy chuyến (100% tiền đặt cọc)
												</p>
											</div>
											<div className="wrap-btn has-2-btn">
												<a className="btn btn-primary btn--m" onClick={this.onCloseModal}>
													Tôi chắc chắn
												</a>
												<a className="btn btn-link" onClick={this.toggleInstantly}>
													Bỏ qua
												</a>
											</div>
										</div>
									</Modal.Body>
								</Modal>
								<Modal
									show={this.state.warn < commonErr.SUCCESS}
									onHide={this.hideWarningBox}
									dialogClassName="modal-sm modal-dialog">
									<Modal.Header closeButton={true} closeLabel={""}>
										<h5>Thông báo</h5>
									</Modal.Header>
									<Modal.Body>
										<div className="form-default form-s">
											<div className="textAlign-center">
												<i className="ic ic-error"></i> {this.state.warnMessage}
											</div>
											<div className="space m"></div>
											<div className="clear"></div>
											<a className="btn btn-primary btn--m" href="/account" target="_blank">
												Cập nhật ngay
											</a>
										</div>
									</Modal.Body>
								</Modal>
								<Modal
									show={this.state.isShowAdditionalPapers}
									onHide={this.toggleShowAdditionalPapers}
									dialogClassName="modal-s modal-input">
									<Modal.Header closeButton={true} closeLabel={""}>
										<h5>Thông tin bổ sung</h5>
									</Modal.Header>
									<Modal.Body>
										<div className="modal-input-body">
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>CCCD/ CMND *</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="idCode"
															type="text"
															className="value"
															placeholder="CCCD/ CMND"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>Ngày cấp CCCD/ CMND</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="idDate"
															type="text"
															className="value"
															placeholder="Ngày cấp CCCD/ CMND"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>Nơi cấp CCCD/ CMND</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="idIssuer"
															type="text"
															className="value"
															placeholder="Nơi cấp CCCD/ CMND"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>Mã số thuế</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="taxCode"
															type="text"
															className="value"
															placeholder="Mã số thuế"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>Ngày cấp MST</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="taxDate"
															type="text"
															className="value"
															placeholder="Ngày cấp MST"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="line-form">
												<div className="custom-input">
													<div className="wrap-info">
														<div className="title-status">
															<p>Nơi cấp MST</p>
														</div>
													</div>
													<div className="wrap-input">
														<input
															name="taxIssuer"
															type="text"
															className="value"
															placeholder="Nơi cấp MST"
															onChange={this.onAdditionalPapersChange}
														/>
													</div>
												</div>
											</div>
											<div className="wrap-btn has-2-btn">
												<a className="btn btn--m btn-primary" disabled={idCode === ""} onClick={this.register}>
													Hoàn tất
												</a>
												<a className="btn btn-link" onClick={this.register}>
													Tôi sẽ bổ sung sau
												</a>
											</div>
										</div>
									</Modal.Body>
								</Modal>
								<Modal
									show={this.state.isShowConfirmPhotos}
									onHide={this.toggleShowConfirmPhotos}
									dialogClassName="modal-s modal-confirm">
									<Modal.Header closeButton={true} closeLabel={""}>
										<h5>Thông báo</h5>
									</Modal.Header>
									<Modal.Body>
										<div className="modal-confirm-body renter-confirm-body">
											<p className="font-16">
												Bạn vui lòng tải lên ít nhất 4 ảnh xe (Trái - Phải - Trước - Sau) để tăng hiểu quả cho thuê và
												đủ điều kiện đăng kí chương trình bảo hiểm thuê xe
											</p>
											<div className="wrap-btn has-2-btn">
												<a className="btn btn--m btn-primary" onClick={this.toggleShowAdditionalPapers}>
													Tôi sẽ bổ sung sau
												</a>
												<a className="btn btn-link" onClick={this.toggleShowConfirmPhotos}>
													Hủy
												</a>
											</div>
										</div>
									</Modal.Body>
								</Modal>
							</div>
						</div>
						<div className="wrap-btn has-2btn">
							<div className="wr-btn">
								<a
									className="btn btn-secondary btn--m"
									disabled={this.state.step === this.state.minStep}
									onClick={this.goPrev}>
									Quay lại
								</a>
							</div>
							{this.state.step < this.state.maxStep && (
								<div className="wr-btn">
									<a className="btn btn-primary btn--m" onClick={this.goNext}>
										Kế tiếp
									</a>
								</div>
							)}
							{this.state.step === this.state.maxStep && (
								<div className="wr-btn">
									<a className="btn btn-primary btn--m" onClick={this.isShowConfirmPhotos}>
										Đăng kí
									</a>
								</div>
							)}
						</div>
					</div>
					<ChangePhone
						show={this.state.showChangePhone}
						hideModal={this.hideChangePhone}
						getProfile={this.getLoggedProfile}
						showVerifyPhoneOpt={this.showVerifyPhoneOpt}
					/>
					{this.state.profile && (
						<VerifyPhone
							show={this.state.showVerifyPhone}
							hideModal={this.hideVerifyPhone}
							profile={this.state.profile}
							getProfile={this.getLoggedProfile}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
					)}
					{this.state.showVerifyPhoneOpt && (
						<VerifyPhoneOpt
							action={otpAction.TOA_VERIFY}
							show={this.state.showVerifyPhoneOpt}
							hideModal={this.hideVerifyPhoneOpt}
							getProfile={this.getLoggedProfile}
							onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
						/>
					)}
					{this.state.showVerifyPhoneOptBreak && (
						<VerifyPhoneOptBreak show={this.state.showVerifyPhoneOptBreak} hideModal={this.hideVerifyPhoneOptBreak} />
					)}
				</section>
				<Footer />
			</div>
		);
	}
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}

CarRegister = connect(mapSessionState)(CarRegister);

export default CarRegister;
